// extracted by mini-css-extract-plugin
export default {"headerListPageSection":"headerListPageSection_KPi9zfM","search":"search_O3D60aQ"};